import axios, { AxiosResponse } from "axios";
import {
    ReceiveUserProfileAction,
    RequestUserProfileAction,
    UpdateUserProfileAction,
} from "../../src/actions/userProfileActions";
import { ProductType } from "../../src/helper/Constants";
import { AppThunkAction, store } from "../../src/store";
import { actionTypes } from "../../src/types/userProfileActionTypes";
import { NotificationAction } from "../../src/store/Common/NotificationStore";

export type DispatchActions = RequestUserProfileAction | ReceiveUserProfileAction | UpdateUserProfileAction;

export type KnownAction = DispatchActions | NotificationAction;

export const requestUserProfile = (): AppThunkAction<KnownAction> => dispatch => {
    dispatch({ type: actionTypes.REQUEST_USER_PROFILE });
    axios.get(`${process.env.REACT_APP_API_URL_SUITE}/api/user-management/user-details`).then((response: any) => {
        const data = response.data;
        dispatch({ type: actionTypes.RECEIVE_USER_PROFILE, user: data });
    });
};

export const resetUserCache = (): AppThunkAction<KnownAction> => () => {
    const user = store.getState().userAuth.user;
    const userId = user?.profile?.user_id;
    const companyId = user?.profile?.company_id;

    axios
        .get(
            `${process.env.REACT_APP_API_URL_SUITE}/api/user-management/reset-user-status-cache/${ProductType.Exchange}/${companyId}/${userId}`,
            {
                withCredentials: true,
            }
        )
        .then((response: AxiosResponse) => {
            console.log(response.data);
        })
        .catch(function (error) {
            console.log(error.data);
        });
};
